<template>
  <v-dialog
    :value="value"
    fullscreen
    content-class="diary-image-viewer"
    @input="$emit('input', $event)"
  >
    <v-card class="viewer-card">
      <v-card-actions class="viewer-toolbar">
        <span>{{ index + 1 }} / {{ images.length }}</span>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="$emit('input', false)"
        >
          {{ $t("\n          Close\n        ") }}
        </v-btn>
      </v-card-actions>
      <v-card-text class="viewer-content">
        <v-btn
          v-if="images.length > 1"
          icon
          dark
          class="viewer-arrow"
          :aria-label="$t(&quot;Previous image&quot;)"
          @click="move(-1)"
        >
          <v-icon>{{ mdiChevronLeft }}</v-icon>
        </v-btn>
        <img
          :src="images[index]"
          :alt="$t(&quot;Diary image enlarged&quot;)"
        />
        <v-btn
          v-if="images.length > 1"
          icon
          dark
          class="viewer-arrow"
          :aria-label="$t(&quot;Next image&quot;)"
          @click="move(1)"
        >
          <v-icon>{{ mdiChevronRight }}</v-icon>
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js'

export default {
  props: {
    value: { type: Boolean, default: false },
    images: { type: Array, default: () => [] },
    index: { type: Number, default: 0 },
  },
  data: () => ({ mdiChevronLeft, mdiChevronRight }),
  watch: {
    value(open) {
      if (open) window.addEventListener('keydown', this.onKeydown)
      else window.removeEventListener('keydown', this.onKeydown)
    },
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKeydown)
  },
  methods: {
    move(step) {
      if (this.images.length < 2) return
      this.$emit('update:index', (this.index + step + this.images.length) % this.images.length)
    },
    onKeydown(event) {
      if (event.key === 'Escape') this.$emit('input', false)
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault()
        this.move(event.key === 'ArrowLeft' ? -1 : 1)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.viewer-card {
  background: #151515;
  color: white;
}
.viewer-toolbar {
  color: white;
  .v-btn { color: white; }
}
.viewer-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px;
  background: #151515;

  img {
    display: block;
    flex: 1 1 auto;
    min-width: 0;
    width: auto;
    max-width: calc(100% - 88px);
    max-height: calc(100dvh - 88px);
    object-fit: contain;
  }
}
.viewer-arrow {
  flex: 0 0 auto;
  color: white;
}
</style>
